let accessToken = '';

export const setAccessToken = (s) => {
  return (accessToken = s);
};

export const getAccessToken = () => {
  return accessToken;
};
